import { Enum } from 'utils';

export const ROLES = Enum(
  'OWNER',
  'ADMIN',
  'MANAGER',
  'AUDIENCE_MANAGER',
  'VIEWER',
);

const { OWNER, ADMIN, MANAGER, AUDIENCE_MANAGER, VIEWER } = ROLES;

export const ROLES_AVAIL = [
  OWNER, ADMIN, MANAGER, VIEWER,
];

export const ADV_PERMS = Enum(
  'CAMP_HISTORY',
  'CAMP_EDIT_ALL_GROUPS',
  'AUD_HISTORY',
  'AUD_PAUSE_SYSTEM',
);

export const PERMS = {
  ADMIN: {
    VIEW: [ADMIN],
  },
  MANAGE: { // app-users management
    VIEW: [ADMIN, MANAGER],
    EDIT: [ADMIN, MANAGER],
  },
  BILLING: {
    VIEW: [ADMIN],
  },
  ADVERS: {
    EDIT: [ADMIN, MANAGER],
    DELETE: [ADMIN],
  },
  APPS: {
    EDIT: [ADMIN, MANAGER],
    DELETE: [ADMIN],
  },
  ADS_ACCS: {
    CREATE: [ADMIN, MANAGER],
    EDIT: [ADMIN, MANAGER],
    DELETE: [ADMIN],
    TOGGLE_SYSTEM: [ADMIN],
  },
  PREDS: { // Predictions
    EDIT: [ADMIN],
  },
  AUDS: { // Audiences
    ADD_ADSACC: [ADMIN, MANAGER, AUDIENCE_MANAGER],
    CREATE: [ADMIN, MANAGER, AUDIENCE_MANAGER],
    EDIT: [ADMIN, MANAGER, AUDIENCE_MANAGER],
    DELETE: [ADMIN, MANAGER],
    HISTORY: [ADMIN, MANAGER],
  },
  CAMPS: { // Campaigns
    CREATE: [ADMIN, MANAGER],
    EDIT: [ADMIN, MANAGER],
    DELETE: [ADMIN],
    HISTORY: [ADMIN, MANAGER],
  },
  CREATIVES: {
    CREATE: [ADMIN, MANAGER],
    EDIT: [ADMIN, MANAGER],
    DELETE: [ADMIN, MANAGER],
  },
  CONVS: {
    VIEW: [ADMIN, MANAGER],
    CREATE: [ADMIN],
    EDIT: [ADMIN, MANAGER],
    DELETE: [ADMIN],
  },
  DATA_SOURCES: {
    CREATE: [ADMIN, MANAGER],
    EDIT: [ADMIN, MANAGER],
    REMOVE: [ADMIN],
  },
};

export const ROLES_TXT = Enum({
  [OWNER]: 'Owner',
  [ADMIN]: 'Admin',
  [MANAGER]: 'Manager',
  [AUDIENCE_MANAGER]: 'Audience Manager',
  [VIEWER]: 'Viewer',
});

// how to sort
export const ROLE_WEIGHT = Enum({
  [OWNER]: 100,
  [ADMIN]: 50,
  [MANAGER]: 10,
  [AUDIENCE_MANAGER]: 9,
  [VIEWER]: 5,
});
